import { useState } from 'react';
import {
  stanceFootRows,
  stanceStopConfirmCopy,
  STANCE_FOOT_SENTENCE,
  type LearningStance,
  type StanceArea,
} from './learning-stance';

/** Shared job-scoped suggestion controls. Opening them never changes preferences. */
export function LearningStanceRows({
  stance,
  onChange,
  busy = false,
}: {
  stance?: LearningStance | null;
  onChange: (area: StanceArea, stoppedAt: string | null) => void;
  busy?: boolean;
}) {
  const [confirming, setConfirming] = useState<StanceArea | null>(null);
  return (
    <div className="jobstance-rows">
      {stanceFootRows(stance).map((row) => {
        const confirm = confirming === row.area ? stanceStopConfirmCopy(row.area) : null;
        return (
          <div key={row.area} className={`jobstance-entry ${row.stopped ? 'stopped' : ''}`}>
            <div className="jobstance-line">
              <span className="jobstance-dot" aria-hidden="true" />
              <strong>{row.label}</strong>
              <span className="jobstance-state">{row.state}</span>
              <button
                className="quiet-button"
                disabled={busy}
                onClick={() =>
                  row.stopped
                    ? onChange(row.area, null)
                    : setConfirming(confirming === row.area ? null : row.area)
                }
              >
                {row.action}
              </button>
            </div>
            {confirm && (
              <div className="jobstance-confirm" role="group" aria-label={confirm.question}>
                <strong>{confirm.question}</strong>
                <p>{confirm.body}</p>
                <small>{confirm.aside}</small>
                <div className="jobstance-confirm-actions">
                  <button
                    className="primary-button"
                    disabled={busy}
                    onClick={() => {
                      setConfirming(null);
                      onChange(row.area, new Date().toISOString());
                    }}
                  >
                    {confirm.confirm}
                  </button>
                  <button className="quiet-button" onClick={() => setConfirming(null)}>
                    {confirm.cancel}
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      })}
      <p className="jobstance-sentence">{STANCE_FOOT_SENTENCE}</p>
    </div>
  );
}
